import React from 'react';
import { NavLink } from 'react-router-dom';
import { Twitter, YouTube, Github, LinkedIn } from '../components/AllSvgs';
import styled from 'styled-components';
import { darkTheme } from '../components/Themes';
import { motion } from 'framer-motion';

const Icons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 2rem;
  z-index: 3;

  & > *:not(:last-child) {
    margin: 0.35rem 0;
  }
`;

const Line = styled(motion.span)`
  width: 2px;
  height: 8rem;
  background-color: ${(props) =>
    props.color === 'dark' ? darkTheme.text : darkTheme.body};
`;

const bounceAnimation = {
  initial: { scale: 0 },
  animate: { 
    scale: [0, 1, 1.5, 0.8, 1],  // Pulsing effect
    opacity: [0, 1, 1, 1, 1] // Ensuring smooth visibility
  },
  transition: { 
    type: 'spring', 
    stiffness: 100, 
    damping: 5,
    duration: 1.2
  }
};

const SocialIcons = (props) => {
  return (
    <Icons>
      {/* GitHub */}
      <NavLink style={{ color: 'inherit' }} target='_blank' to="https://github.com/EdwardNdiyo">
        <motion.div {...bounceAnimation} transition={{ ...bounceAnimation.transition, delay: 1 }}>
          <Github width={25} height={25} fill={props.theme === "dark" ? darkTheme.text : darkTheme.body} />
        </motion.div>
      </NavLink>

      {/* Twitter */}
      <NavLink style={{ color: 'inherit' }} target='_blank' to="https://x.com/_ed__Ward_">
        <motion.div {...bounceAnimation} transition={{ ...bounceAnimation.transition, delay: 1.2 }}>
          <Twitter width={25} height={25} fill={props.theme === "dark" ? darkTheme.text : darkTheme.body} />
        </motion.div>
      </NavLink>

      {/* LinkedIn (Replace Facebook icon with LinkedIn if needed) */}
      <NavLink style={{ color: 'inherit' }} target='_blank' to="https://www.linkedin.com/in/edward-ndiyo-a349b918b">
        <motion.div {...bounceAnimation} transition={{ ...bounceAnimation.transition, delay: 1.4 }}>
          <LinkedIn width={25} height={25} fill={props.theme === "dark" ? darkTheme.text : darkTheme.body} />
        </motion.div>
      </NavLink>

      {/* YouTube */}
      <NavLink style={{ color: 'inherit' }} target='_blank' to="https://youtube.com/channel/UCPeNZRwtzbYXSvLvuNxwWwg">
        <motion.div {...bounceAnimation} transition={{ ...bounceAnimation.transition, delay: 1.6 }}>
          <YouTube width={25} height={25} fill={props.theme === "dark" ? darkTheme.text : darkTheme.body} />
        </motion.div>
      </NavLink>

      {/* Animated Line */}
      <Line
        color={props.theme}
        initial={{ height: 0 }}
        animate={{ height: '8rem' }}
        transition={{ type: 'spring', duration: 1, delay: 0.8 }}
      />
    </Icons>
  );
};

export default SocialIcons;
